import axios from 'axios';
import queryString from 'query-string';
import { storage } from '../constants';
import { redirectIQ } from '../utlis/helper';
import config from '../config';
const { API_BASE_URL } = config;

axios.interceptors.request.use(function (config) {
    // Serialize the parameteters
    config.paramsSerializer = params => queryString.stringify(params, { arrayFormat: 'brackets' });
    return config;
});

axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        console.error('Session Error: ', error);
        if (error.response && error.response.status === 401) {
            redirectIQ();
        }
        
        return Promise.reject(error);
    }
);

export default {
    request: async (options) => {
        options.baseURL = API_BASE_URL;
        const token = options?.params?.token || window.sessionStorage.getItem(storage.TOKEN) || null;
        const symbol = options?.params?.symbol || window.sessionStorage.getItem(storage.SYMBOL) || null;
        const url = options.url;
        const ipAPI = url.includes('api.ipify.org');
        
        if (options.isOTC) {
            if (!options.params) options.params = {};
            options.params.symbol = symbol.toUpperCase();
        }

        if (token && !ipAPI) {
            if (!options.headers) options.headers = {};
            options.headers.Authorization = `Bearer ${token}`;
        }

        const response = await axios(options);
        return response;
    }
};
